import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { FlexColumn, Margin } from '@/@bothrs-ui/web/components/layout'
import { Modal } from '@/@bothrs-ui/web/components/modal/Modal'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'

import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import type { InheritableModalProps } from '@/@bothrs-ui/web/components/modal/Modal.props'

type Props = InheritableModalProps & {
  onAction: () => void
  title: string
  body?: string
  actionButtonText?: string
  cancelButtonText?: string
  icon?: IconProp
  /** Spins the action button and blocks both buttons while the action runs. */
  isLoading?: boolean
}

export const ConfirmationModal = ({
  onAction,
  title,
  body,
  actionButtonText,
  cancelButtonText,
  icon,
  isLoading,
  ...props
}: Props) => {
  const theme = useTheme()

  return (
    <Modal {...props}>
      <FlexColumn alignContent='center'>
        <FontAwesomeIcon icon={icon || ['fal', 'question-circle']} fontSize={24} />

        <Margin mt={theme.UI.Spacing.Space5} />

        <H3 textAlign='center' color={theme.Colors.Neutrals.Darkest}>
          {title}
        </H3>
        {body ? (
          <P type='BodyLargeRegular' textAlign='center' color={theme.Colors.Neutrals.Darker}>
            {body}
          </P>
        ) : null}
        <Button variant='Primary' onClick={onAction} disabled={isLoading} isLoading={isLoading}>
          {actionButtonText ||
            t({
              message: 'Bevestigen',
            })}
        </Button>
        <Margin mt={theme.UI.Spacing.Space2} />
        <Button variant='Tertiary' onClick={props.onClose} disabled={isLoading}>
          {cancelButtonText ||
            t({
              message: 'Annuleren',
            })}
        </Button>
      </FlexColumn>
    </Modal>
  )
}
